import React from 'react';
import View from '../../../components/Telemedicine/AppointmentsMain/ViewMain/SAAppointmentsView'
const Appointments = () => {
  return <div><View/></div>;
};

export default Appointments;
